<script>
import formCreate from '@/components/iglobalwin/formPanelGroups/index.js';
import formComponents from '@/components/iglobalwin/formComponents/common/index.js';
import googleads from '@/backend/services/googleAds/googleAds.js';
// import utils from '@/utils';
import {
	required,
	requiredCustomVm
} from '@/utils/validate';

const {
	skyInput,
	// skySelect,
	skyTextarea,
	skyRadioBtn,
	// skyCheckbox,
	skySelectInput,
	// skyCheckboxPanel,
	// skyCascaderPanel,
	// skyDatePicker,
	// skyWeektime,
	skyProKeywords,
	skySlogan,
	selectProductDetail
} = formComponents;

function isEditPage(vm) {
	const edit = vm.$route.query.edit;
	const isEdit = edit !== null && edit !== undefined;
	return isEdit;
}

function getGroups(pageData, vm) {
	let { isEdit, domain, device, detail } = pageData;

	return {
		setting: {
			title: '广告组基本设置',
			items: {
				tips: {
					label: '',
					type: selectProductDetail,
					domain: domain,
					value: [],
					visable(vm) {
						return !isEdit;
					},
				},
				name: {
					label: '广告组名称',
					placeholder: '请输入广告组名称',
					type: skyTextarea,
					value: '',
					rules: [required('请输入广告组名称')],
					width: '50%',
					maxlength: '255',
					'show-word-limit': true,
					onChange: valueChange,
				},
				status: {
					label: '默认状态',
					type: skyRadioBtn,
					value: 'ENABLED',
					options: [
						{
							name: '启用',
							code: 'ENABLED',
						},
						{
							name: '暂停',
							code: 'PAUSED',
						},
					],
					// code: 'CampaignPlanType',
					rules: [required('请选择默认状态')],
				},
				cpcBidMicros: {
					label: '默认出价',
					placeholder: '请输入出价',
					type: skyInput,
					value: '3.01',
					width: '50%',
					unit: '元',
					rules: [required('请输入出价')],
				},
				deviceType: {
					label: '设备出价调整',
					type: skyRadioBtn,
					value: device.deviceType,
					options: [
						{
							name: '不调整',
							code: '0',
						},
						{
							name: '调整',
							code: '1',
						},
					],
					// code: 'CampaignPlanType',
					rules: [required('请选择设备出价调整')],
					filterOptions(data) {
						return data.map(item => {
							return {
								...item,
								disabled: () => {
									// 平板电脑 或 计算机 或 手机 为 降低100 时，不调整 为禁用
									let val = vm.formData.fields;
									if(item.code == '0') {
										return (val.tablet.value.type == 1 && val.tablet.value.bidModifier == '100') ||
										(val.deskTop.value.type == 1 && val.deskTop.value.bidModifier == '100') ||
										(val.moile.value.type == 1 && val.moile.value.bidModifier == '100')
									}
									return false;
								},
							};
						});
					},
				},
				tablet: {
					label: '平板电脑',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: '',
						resourceName: null
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					disabled: false,
					filterOptions() {
						if(device.deviceType == '0' || !device.tablet) {
							// 设备不调整直接返回false
							return false
						}
						let val = vm.formData.fields;
						// 如果父级广告系列为 减低100 时，当前项为减低100 并禁用当前项
						if(!val.tablet.disabled && device.tablet.type == 1 && device.tablet.bidModifier == '100') {
							val.tablet.value = {
								type: device.tablet.type,
								bidModifier: device.tablet.bidModifier,
								resourceName: detail ? detail.tablet.resourceName : null
							};
							val.tablet.disabled = true;
							return false;
						}else if(device.tablet.bidModifier && !val.tablet.value.bidModifier && !val.tablet.value.resourceName) {
							// 如果父级广告系列有值，当前项为空时，直接把父级值赋给当前项
							val.tablet.value = {
								type: device.tablet.type,
								bidModifier: device.tablet.bidModifier,
								resourceName: detail ? detail.deskTop.resourceName : null
							};
							val.tablet.disabled = false;
							return false;
						}
						return false;
					},
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
				deskTop: {
					label: '计算机',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: '',
						resourceName: null
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					disabled: false,
					filterOptions() {
						if(device.deviceType == '0' || !device.deskTop) {
							// 设备不调整直接返回false
							return false
						}
						let val = vm.formData.fields;
						// 如果父级广告系列为 减低100 时，当前项为减低100 并禁用当前项
						if(!val.deskTop.disabled && device.deskTop.type == 1 && device.deskTop.bidModifier == '100') {
							val.deskTop.value = {
								type: device.deskTop.type,
								bidModifier: device.deskTop.bidModifier,
								resourceName: detail ? detail.deskTop.resourceName : null
							};
							val.deskTop.disabled = true;
							return false;
						}else if(device.deskTop.bidModifier && !val.deskTop.value.bidModifier && !val.deskTop.value.resourceName) {
							// 如果父级广告系列有值，当前项为空时，直接把父级值赋给当前项
							val.deskTop.value = {
								type: device.deskTop.type,
								bidModifier: device.deskTop.bidModifier,
								resourceName: detail ? detail.deskTop.resourceName : null
							};
							val.deskTop.disabled = false;
							return false;
						}
						return false;
					},
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
				moile: {
					label: '手机',
					type: skySelectInput,
					placeholder: '请输入',
					value: {
						type: 1,
						bidModifier: '',
						resourceName: null
					},
					options: [
						{
							name: '提高',
							code: 0,
						},
						{
							name: '降低',
							code: 1,
						},
					],
					unit: '%',
					width: '50%',
					disabled: false,
					filterOptions() {
						if(device.deviceType == '0' || !device.moile) {
							// 设备不调整直接返回false
							return false
						}
						let val = vm.formData.fields;
						// 如果父级广告系列为 减低100 时，当前项为减低100 并禁用当前项
						if(!val.moile.disabled && device.moile.type == 1 && device.moile.bidModifier == '100') {
							val.moile.value = {
								type: device.moile.type,
								bidModifier: device.moile.bidModifier,
								resourceName: detail ? detail.moile.resourceName : null
							};
							val.moile.disabled = true;
							return false;
						}else if(device.moile.bidModifier && !val.moile.value.bidModifier && !val.moile.value.resourceName) {
							// 如果父级广告系列有值，当前项为空时，直接把父级值赋给当前项
							val.moile.value = {
								type: device.moile.type,
								bidModifier: device.moile.bidModifier,
								resourceName: detail ? detail.deskTop.resourceName : null
							};
							val.moile.disabled = false;
							return false;
						}
						return false;
					},
					visable(vm) {
						return vm.formData.fields.deviceType.value == 1;
					},
				},
			},
		},
		pos: {
			title: '关键词',
			items: {
				keyWordType: {
					label: '',
					type: skyRadioBtn,
					value: '1',
					options: [
						{
							name: '添加关键词',
							code: '1',
						},
						{
							name: '暂不添加',
							code: '0',
						},
					],
				},
				addKeyWordBaseDto: {
					label: '',
					type: skyProKeywords,
					value: {
						keyWordDtos: [],
						negativeKeyWords: [],
					},
					keywordsList: [],
					excludedKeywordsList: [],
					load: false,
					domain: domain,
					visable(vm) {
						return vm.formData.fields.keyWordType.value == '1';
					},
				}
			},
		},
		date: {
			title: '设置广告语',
			items: {
				adType: {
					label: '',
					type: skyRadioBtn,
					value: '1',
					options: [
						{
							name: '添加广告语',
							code: '1',
						},
						{
							name: '暂不添加',
							code: '0',
						},
					],
					visable(vm) {
						return !isEdit;
					},
				},
				adDto: {
					label: '',
					type: skySlogan,
					value: {
						headlines: [],
						descriptions: [],
						finalUrls: ''
					},
					domain: domain || '',
					productUrl: '',
					isValidate: false,
					changeVal: (res) => {
						changeVal(res, vm)
					},
					aiWrite: (list) => {
						aiWrite(list, vm)
					},
					rules: [
						requiredCustomVm('请检查广告输入内容是否正确', function(val, vm) {
							return vm.formData.fields.adDto.isValidate;
						})
					],
					visable(vm) {
						return vm.formData.fields.adType.value === '1';
					},
				}
			}
		}
	};
}

// 预加载数据
async function pageData(vm) {
	const isEdit = isEditPage(vm);
	const domain = await getServiceDomain(vm); // 获取服务单域名
	const device = await getCampaignDevice(vm); // 获取设备数据
	if (isEdit) {
		const detail = await getAdgroupEditDetail(vm); //获取广告组详情
		return {
			isEdit,
			domain,
			device,
			detail,
		};
	} else {
		return {
			isEdit,
			domain,
			device,
		};
	}
}

function getFormData({ pageData }, vm) {
	let { isEdit, detail } = pageData;
	const groups = getGroups(pageData, vm);
	if (isEdit) {
		// 编辑时，去除关键词和广告语
		delete groups['pos'];
		delete groups['date'];
		return SetGroupFormValue(groups, detail);
	} else {
		return groups;
	}
}
// 编辑表单时value值回显填入
function SetGroupFormValue(groups, obj) {
	Object.keys(groups).forEach(groupKey => {
		Object.keys(groups[groupKey].items).forEach(itemKey => {
			// 如果obj[itemKey]不存在或者为空值时，表单则取自己原来的默认值。
			groups[groupKey].items[itemKey].value = obj[itemKey] || groups[groupKey].items[itemKey].value;
		});
	});
	return groups;
}

// 处理表单变化
async function valueChange(vm, field) {
	if(vm.errorMsgList && vm.errorMsgList.length) {
		vm.validateAll().then(msg => {
			vm.errorMsgList = msg;
		})
	}
	if(field.itemName === 'tips') {
		// 如果产品值改变，获取关键词数据
		let res = await productkeyword(field.value);
		vm.formData.fields.addKeyWordBaseDto.keywordsList = res.data || [];
		vm.formData.fields.addKeyWordBaseDto.excludedKeywordsList = res.data.removeKeywordList || [];
		vm.formData.fields.addKeyWordBaseDto.load = false;
		vm.formData.fields.adDto.productUrl = field.value;
		
		if(!vm.formData.fields.name.value) {
			// 如果选中产品，自动填充名称到“广告组名称”，已有时不做替换
			vm.formData.fields.name.value = field.value[0].name;
		}
	}
}

function changeVal(val,vm) {
	// 校验广告语规则是否成功
	vm.formData.fields.adDto.isValidate = val;
}

function aiWrite(val,vm) {
	// ai撰写
	vm.formData.fields.tips.value = val;
}

// 获取广告组详情数据
async function getAdgroupEditDetail(vm) {
	const res = await googleads.getAdgroupEditDetail(vm.$route.query.edit);
	return res.data;
}


// 根据选中的产品或产品分类 获取关键词
async function productkeyword(obj) {
	let res = await googleads.getKeywordProduct({
			url: obj[0].path,
	});
	return res;
};

// 获取服务单域名
async function getServiceDomain(obj) {
	let res = await googleads.getServiceDomain();
	return res.data;
};
// 获取设备数据
async function getCampaignDevice(vm) {
	let res = await googleads.getCampaignDevice({
		id: vm.$route.query.adSeriesId
	});
	return res.data;
};

// 提交
async function submit(data) {
	const isEdit = this.$route.query.edit;
	let res;
	delete data['tips'];
	if(isEdit) {
		// 编辑
		data['resourceName'] = this.$route.query.resourceName;
		res = await googleads.getAdgroupUpdate(data);
	}else {
		// 新建
		data['campaign'] = this.$route.query.resourceName;
		res = await googleads.addAdgroup(data);
	}
	// 成功后返回广告列表，并选中“广告组1”
	this.$router.push({
		name: 'accountManagement',
		query: {
			adSeriesId: this.$route.query.adSeriesId,
			adSeriesName: this.$route.query.adSeriesName,
			adGroupId: res.data.id,
			adGroupName: res.data.name,
			resourceName: res.data.resourceName,
		},
	});
	if(res.status == 200 && !res.data.error) {
		this.$message.success(isEdit ? '编辑广告组成功！' : '新建广告组成功！');
	}else {
		this.$message.error(isEdit ? '编辑广告组失败！' : '新建广告组失败！');
	}
}

function titleTooltipInfo() {
	return {
		tit: isEditPage(this) ? '编辑广告组' : '新建广告组',
		tip: [
			'广告组：广告组包含一个或多个共用类似定位条件的广告。',
			'· 每个广告系列由一个或多个广告组构成。',
			'· 您可以使用广告组来按共同的主题组织您的广告。例如，您可以按不同的产品或服务类型来划分广告组。',
		],
		item: {
			'所属广告系列': this.$route.query.adSeriesName + '（ID：'+this.$route.query.adSeriesId+'）'
		}
	};
}

// 返回
function goBack(vm) {
	// 确认后返回广告组列表，选中父级广告系列
	vm.$router.push({
		name: 'accountManagement',
		query: {
			adSeriesId: vm.$route.query.adSeriesId,
			adSeriesName: vm.$route.query.adSeriesName,
		},
	});
}

// 取消-返回
function cancel(vm) {
	vm.$confirm('将不保存已填写的内容,确认后返回广告组列表，选中父级广告系列', '提示', {
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning',
	})
		.then(() => {
			goBack(vm);
		})
		.catch(() => {
			return;
		});
}

export default formCreate({
	getFormData,
	load: {
		pageData,
	},
	submit,
	cancel,
	showNavPanel: true,
	goBack,
	labelWidth: '180px',
	titleTooltip: true,
	titleTooltipInfo,
});
</script>
